import { Injectable, Injector } from "@angular/core";
import { BaseResourceService } from "@sicapes/core";
import { BehaviorSubject, Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Recurso } from "../../models/inscricao/recurso.model";
import { Reconsideracao } from "../../models/recurso/Reconsideracao.model";
import { ReconsideracaoData } from "../../models/recurso/ReconsideracaoData.model";
import { HttpHeaders } from "@angular/common/http";
import { Buffer } from "buffer";

@Injectable({
    providedIn: 'root'
})
export class RecursoService extends BaseResourceService<Recurso> {
    constructor(protected injector: Injector,) {
        super('rest/inscricoes', injector, Recurso.fromJson);
    }

    public reconsideracao: Reconsideracao;
    protected reconsideracaoSubject: BehaviorSubject<Reconsideracao> = new BehaviorSubject<Reconsideracao>({});
    protected reconsideracaoOservable: Observable<Reconsideracao> = this.reconsideracaoSubject.asObservable();
    public simuladorAcesso = null;

    /**
     * Obtem dados do recurso
     *
     * @param {*} proponente
     * @param {*} codigo
     * @returns {Observable<Recurso>}
     * @memberof RecursoService
     */
    public obterRecurso(proponente, codigo): Observable<Recurso> {
        const url = 'rest/inscricoes/' + proponente + '/' + codigo + '/recurso';
        return this.http.get(url)
            .pipe(
                map(this.jsonDataToResource.bind(this)), catchError(this.handleError)
            );
    }

    /**
     * Obtem dados do recurso
     *
     * @param {*} proponente
     * @param {*} codigo
     * @returns {Observable<Recurso>}
     * @memberof RecursoService
     */
    public obterRecursos(proponente, codigo): Observable<any> {
        const url = 'rest/inscricoes/' + proponente + '/' + codigo + '/recurso';
        return this.http.get(url);
    }

    /**
     *
     *
     * @param {string} proponente
     * @param {string} codigo
     * @param {Recurso} recurso
     * @returns {Observable<Recurso>}
     * @memberof RecursoService
     */
    public salvarRecurso(proponente: string, codigo: string, recurso: Recurso): Observable<Recurso> {
        const url = 'rest/inscricoes/' + proponente + '/' + codigo + '/recurso/' + recurso.id;
        return this.http.put(url, recurso);
    }
    /**
     *
     *
     * @param {string} proponente
     * @param {string} codigo
     * @returns {*}
     * @memberof RecursoService
     */
    public enviarParaAnalise(proponente: string, codigo: string): any {
        const url = 'rest/inscricoes/' + proponente + '/' + codigo + '/submeter-recurso';
        return this.http.post(url, {})
    }



    public removerAnexoRecurso = function (proponente: string, codigo: string, participante: any, documento: number) {

        var url =
            '/rest/inscricoes/' +
            proponente + '/' +
            codigo +
            "/participantes/" +
            participante +
            "/informacoes-documentos/" +
            documento;

        return this.http.delete(url);
    }


    public httpSimHeader = (blob: boolean = false) => {
        let opt = {}
        let list = {}
        if (blob) {
            list = {
                ...list,
                "responseType": 'blob' as 'json'
            }
        }
        if (this.simuladorAcesso) {
            list = {
                ...list,
                'AccessSimulator': this.simuladorAcesso,
            }

        }
        opt = { headers: new HttpHeaders(list) };
        return opt;
    }
    // RECONSIDERACAO - OCORRENCIA
    /**
     * The `setReconsideracaoAtiva` method in the `RecursoService` class is a public method that takes
     * a `Reconsideracao` object as a parameter. It sets the active reconsideration by updating the
     * `reconsideracaoSubject` BehaviorSubject with the new `Reconsideracao` object using the `next`
     * method. This method essentially updates the active reconsideration data in the service for other
     * parts of the application to access and subscribe to changes.
     *
     * @param {Reconsideracao} reconsideracao
     * @memberof RecursoService
     */
    public setReconsideracaoAtiva = (reconsideracao: Reconsideracao): void => {
        this.reconsideracao = { ...reconsideracao };
        return this.reconsideracaoSubject.next(this.reconsideracao);
    }

    /**
     * The `getReconsideracaoAtiva` method in the `RecursoService` class is a public method that
     * returns an Observable of type `Reconsideracao`. It is an arrow function that directly returns
     * the `reconsideracaoOservable` property of the service. This property is an Observable of type
     *
     * @returns Observable<Reconsideracao>
     * @memberof RecursoService
     */
    public getReconsideracaoAtiva = (): Observable<Reconsideracao> => {
        return this.reconsideracaoOservable;
    }

    public obterReconsideracoes = () => {
        console.log("obterReconsideracoes", this.httpSimHeader())
        var url = `/rest/recurso/reconsideracao`;
        return this.http.get(url, this.httpSimHeader());
    }

    public obterReconsideracao = (id: number): Observable<ReconsideracaoData> => {
        var url = `/rest/recurso/reconsideracao/${id}`;
        return this.http.get(url, this.httpSimHeader());
    }


    public obterDocumentosReconsideraco = (idOcorrencia, idEtapaAnalise) => {

        let url = `/rest/recurso/documento` +
            `?idOcorrencia=${idOcorrencia}&idEtapaAnalise=${idEtapaAnalise}`;
        return this.http.get(url, this.httpSimHeader());
    }

    public salvarDocumentoReconsideracao = (documento, tipo, informacao): any => {
        var url = `/rest/recurso/documento`;
        var body = {
            tipo: tipo,
            arquivo: documento,
            reconsideracaoInformacao: informacao
        }
        return this.http.post(url, body, this.httpSimHeader());
    }
    public excluirDocumentoReconsideracao = (documento): any => {
        var url = `/rest/recurso/documento/${documento.id}`;
        return this.http.delete(url, this.httpSimHeader());
    }

    public salvarReconsideracao = (reconsideracao) => {
        var url = `/rest/recurso/reconsideracao/${reconsideracao.id}`;
        return this.http.put(url, reconsideracao, this.httpSimHeader());
    }

    public enviarReconsideracaoParaAvaliacao = (reconsideracaoData) => {
        let url = `/rest/recurso/enviar-recurso`;
        return this.http.post(url, reconsideracaoData, this.httpSimHeader());
    }
    public downloadParecer = (idParecer, idOcorrencia, idEtapaAnalise) => {
        let url = `/rest/recurso/documento?idParecer=${idParecer}&idOcorrencia=${idOcorrencia}&idEtapaAnalise=${idEtapaAnalise}`;
        return this.http.get(url, this.httpSimHeader(true));
    }

    public obterDocumentosParecer = (idOcorrencia: number) => {
        const url = `/rest/recurso/documento-analise?idOcorrencia=${idOcorrencia}`;
        return this.http.get(url, this.httpSimHeader());
    }
    public downloadDocumentosParecerAnalise = (documentoParecer) => {
        let url = `/rest/recurso/documento-analise/${documentoParecer.id}?url=` + Buffer.from(documentoParecer.dsUrlArquivo).toString('base64')
            + `&nome=` + documentoParecer.nmArquivo;

        return this.http.get(url, this.httpSimHeader(true));
    }
}